import React from "react";

import ProfilesLinkingDropdown from "../../Form/components/FormPrefiller/ProfilesLinkingDropdown";

import GQLUtil from "../../../global/utils/gqlHelper";
import PrefillUtil from "../../../global/utils/prefillHelper";
import ViewEntityQueryResolver from "../../../data/queries/profiles/profilesById/resolver";
import MappingResolver from "../../../data/schema/profiles/mappingResolver";

import { profilesQuery } from "../../Form/components/FormPrefiller/query";

class Prefiller extends React.Component {
  constructor() {
    super();
    this.state = {
      index: -1,
      selected: "-Select-",
      profiles: [],
    };
    this.selectProfile = this.selectProfile.bind(this);
    this.prefill = this.prefill.bind(this);
  }

  async componentDidMount() {
    if (this.props.schema == "appendixCforeignlaborSchemahere") {
      const profiles = await GQLUtil.genericGQLQuery(profilesQuery);
      const parsedProfiles = PrefillUtil.getPrefillProfileOptions(
        profiles.data.getUserProfileInfo,
        this.props.formDetailName,
        this.props.schema
      );
      this.setState({
        profiles: parsedProfiles,
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.schema !== prevProps.schema) {
      this.setState({
        profiles: [],
        index: -1,
      });
    }
  }

  //TODO: get profiles
  selectProfile(value) {
    if (this.props.schema == "appendixCforeignlaborSchemahere") {
      this.setState({
        index: value,
        selected: this.state.profiles[value],
      });
    } else {
      this.setState({
        index: value,
        selected: this.props.profiles[value],
      });
    }
  }

  async prefill(profile) {
    let formApi = this.props.formApi;
    //get the data
    const query = ViewEntityQueryResolver(this.state.selected.type, this.state.selected.id);
    const data = await GQLUtil.genericGQLQuery(query);

    const dataKeys = PrefillUtil.dataResolver(this.state.selected.type);
    let rawData = data.data[dataKeys.query][dataKeys.formDataName];

    //get the map
    const mapping = PrefillUtil.getPrefillSchemaMapping(
      this.state.selected.type,
      this.props.formDetailName,
      this.props.schema
    );
    const mappingSchema = MappingResolver(mapping);

    //send the data via the map
    formApi.batch(() => {
      mappingSchema.fields.forEach((field) => {
        formApi.change(field.formTargetField, rawData[field.profileFieldName]);
      });
    });
  }

  render() {
    if (this.props.schema == "appendixCforeignlaborSchemahere") {
      if (this.state.profiles.length > 0) {
        return (
          <div>
            <ProfilesLinkingDropdown
              profiles={this.state.profiles}
              selectProfile={this.selectProfile}
              prefill={this.prefill}
              selected={this.state.selected}
              index={this.state.index}
            />
          </div>
        );
      } else if (this.state.profiles.length == 0) {
        return null;
      }
    } else {
      return (
        <div>
          <ProfilesLinkingDropdown
            profiles={this.props.profiles}
            selectProfile={this.selectProfile}
            prefill={this.prefill}
            selected={this.state.selected}
            index={this.state.index}
          />
        </div>
      );
    }
  }
}

export default Prefiller;
